import { createEntityAdapter, EntityState, EntityAdapter } from '@ngrx/entity';
import { Application } from '../../../models/application.model';
import * as applicationActions from '../actions/applications.actions';
import { ActionType } from '../actions/applications.actions';


export interface State extends EntityState<Application> { fetchRunning: null; addApplicationStatus: { status: null, id: null }; }

export const applicationAdapter: EntityAdapter<Application> = createEntityAdapter<Application>();

export const initialState: State = applicationAdapter.getInitialState({ fetchRunning: null, addApplicationStatus: { status: null, id: null } });


export function applicationReducer(
  state: State = initialState,
  action: applicationActions.ApplicationActions
) {
  switch (action.type) {

    case ActionType.FETCH_APPLICATIONS_BY_APPID_SUCCESS:
      return applicationAdapter.setAll(action.applications, {
        ...state,
        fetchRunning: false,
      });

    case ActionType.FETCH_APPLICATIONS_SUCCESS:
      return applicationAdapter.setAll(action.applications, {
        ...state,
        fetchRunning: false,
      });

    case ActionType.FETCH_APPLICATIONS_BY_COMPANYID_SUCCESS:
      return applicationAdapter.setAll(action.applications, {
        ...state,
        fetchRunning: false,
      });

    case ActionType.FETCH_APPLICATIONS_BY_COMPANYIDSITEID_SUCCESS:
      return applicationAdapter.setAll(action.applications, {
        ...state,
        fetchRunning: false,
      });

    case ActionType.ADD_APPLICATION:
      return {
        ...state,
        fetchRunning: true,
        addApplicationStatus: { status: false, id: null }
      };
    case ActionType.ADD_APPLICATION_SUCCESS:
      return applicationAdapter.addOne(action.application, {
        ...state,
        fetchRunning: false,
        addApplicationStatus: { status: true, id: action.application.id }
      });

    case ActionType.ADD_APPLICATION_FAILED:
      return {
        ...state,
        fetchRunning: false,
        addApplicationStatus: { status: false, id: null }
      };

    case ActionType.DELETE_APPLICATION:
      return {
        ...state,
        fetchRunning: true,
      };
    case ActionType.DELETE_APPLICATION_SUCCESS:
      return applicationAdapter.removeOne(action.id, {
        ...state,
        fetchRunning: false,
      });

    case ActionType.DELETE_APPLICATION_FAILED:
      return {
        ...state,
        fetchRunning: false,
      };
    case ActionType.UPDATE_APPLICATION:
      return {
        ...state,
        fetchRunning: true,
      };
    case ActionType.UPDATE_APPLICATION_SUCCESS:
      return {
        ...state,
        fetchRunning: false,
      };
    case ActionType.UPDATE_APPLICATION_FAILED:
      return {
        ...state,
        fetchRunning: false,
      };



    //  return applicationAdapter.addOne(action.payload.application, state);
    // case applicationActions.TOGGLE_DONE:
    //   return applicationAdapter.updateOne(
    //     { id: action.payload.id, changes: { done: action.payload.done } },
    //     state
    //   );
    // case applicationActions.UPDATE_APPLICATION:
    //   return applicationAdapter.updateOne(
    //     { id: action.payload.id, changes: { value: action.payload.newValue } },
    //     state
    //   );
    // case applicationActions.DELETE_APPLICATION:
    // return applicationAdapter.removeOne(action.payload.id, state);



    default:
      return state;
  }
}

export const getFetchRunning = (state: State) => state.fetchRunning;
export const getSiteStatus = (state: State) => state.addApplicationStatus;
